//import { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade } from "swiper/modules";
import { FaInstagram, FaFacebookF } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { FaPhoneAlt } from "react-icons/fa";
import "swiper/css";
//import "swiper/css/pagination";
//import "swiper/css/navigation";
import "swiper/css/effect-fade";

// IMPORT YOUR IMAGES
import moffee1 from "./assets/MoffeeImage1.png";
import moffee2 from "./assets/MoffeeImage3.png";
import moffee3 from "./assets/MoffeeFront4.jpg";
import moffee4 from "./assets/MoffeeBack5.jpg";
import moffee5 from "./assets/MoffeeImage6.jpg";
import moffee6 from "./assets/MoffeeImage7.jpg";

import choco1 from "./assets/ChocoshroomImage1.png";
import choco2 from "./assets/ChocoshroomImage3.png";
import choco3 from "./assets/ChocoshroomFront4.jpg";
import choco4 from "./assets/ChocoshroomBack5.jpg";
import choco5 from "./assets/ChocoshroomImage6.jpg";
import choco6 from "./assets/ChocoshroomImage7.pjpg";


import MMLogopdf from "./assets/myfinalLogo.png";
import Contact from "./components/Contact";
import Navbar from "./components/Navbar";
import OfferPopup from "./components/OfferPopup";

export default function App() {
  //const [open, setOpen] = useState(false);

  return (
    <div className="font-sans text-[#2d2d2d]">

<OfferPopup />
      {/* NAVBAR */}
      <Navbar/>
      {/* HERO SECTION */}
      {/* HERO SECTION */}
<section id="home">
  <picture>
    {/* Desktop */}
    <source
      media="(min-width: 768px)"
      srcSet="/desktop-banner.png"
    />

    {/* Mobile */}
    <img
      src="/mobile-banner.png"
      alt="Moffee Magic Banner"
      className="w-full block"
    />
  </picture>
</section>

      {/* PRODUCTS */}
      {/* PRODUCTS */}
<section
  id="products"
  className="py-16 sm:py-20 px-4 sm:px-6 bg-gradient-to-b from-[#f8f6f3] to-[#f3eee8]"
>
  <div className="max-w-6xl mx-auto">

    {/* SECTION TITLE */}
    <div className="text-center mb-14">
      <h2 className="text-4xl sm:text-4xl font-semibold text-[#1c1c1c] mb-3">
        Our Products
      </h2>

      <p className="text-gray-500 max-w-xl mx-auto">
        Discover our modern wellness ritual that blends premium coffee, rich cacao, and functional ingredients - Magically uniting health and taste.
      </p>
    </div>

    {/* PRODUCT GRID */}
      {/* ================= MOFFEE SHOWCASE ================= */}

<div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center bg-white rounded-[32px] overflow-hidden shadow-lg border border-[#ece7df]">

  {/* LEFT SIDE — IMAGE SHOWCASE */}
  <div className="bg-[#f7f2eb] h-full flex items-center justify-center p-4 sm:p-6">

    <div className="w-full max-w-[520px]">

      <Swiper
        modules={[Autoplay, EffectFade]}
        effect="fade"
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        loop={true}
        className="rounded-[28px] overflow-hidden"
      >
        <SwiperSlide>
          <img
            src={moffee3}
            alt="Moffee"
            className="w-full object-cover rounded-[28px]"
          />
        </SwiperSlide>

        <SwiperSlide>
          <img
            src={moffee4}
            alt="Moffee"
            className="w-full object-cover rounded-[28px]"
          />
        </SwiperSlide>

        <SwiperSlide>
          <img
            src={moffee1}
            alt="Moffee"
            className="w-full object-cover rounded-[28px]"
          />
        </SwiperSlide>

        <SwiperSlide>
          <img
            src={moffee2}
            alt="Moffee"
            className="w-full object-cover rounded-[28px]"
          />
        </SwiperSlide>
        <SwiperSlide>
          <img
            src={moffee5}
            alt="Moffee"
            className="w-full object-cover rounded-[28px]"
          />
        </SwiperSlide>
        <SwiperSlide>
          <img
            src={moffee6}
            alt="Moffee"
            className="w-full object-cover rounded-[28px]"
          />
        </SwiperSlide>

      </Swiper>

    </div>

  </div>

  {/* RIGHT SIDE — PRODUCT DETAILS */}
  <div className="p-6 sm:p-7">

    {/* TITLE */}
    <h3 className="text-2xl sm:text-[32px] font-semibold text-[#1a1a1a] uppercase mb-4">
      Moffee
    </h3>

    {/* LABEL */}
    <p className="text-[#d68c45] text-sm font-medium tracking-[3px] uppercase mb-2">
      Energy & Focus Blend
    </p>

    

    {/* DESCRIPTION */}
    <p className="text-gray-600 text-[17px] leading-8 mb-6 max-w-xl">
      Meet MOFFEE (Mushroom Coffee) a thoughtfully crafted daily ritual that blends the richness of 100% Arabica Araku Instant Coffee with the power of functional fruiting body mushroom extracts for smooth energy, calm focus and a better way to caffeinate.
    </p>

    <p className="alex-font text-[22px] text-[#5c4033] leading-tight mb-4">
        Focus Better. Feel Better. Brew Better.
    </p>

    {/* PRICE + WEIGHT */}
    <div className="flex items-center justify-between mb-6">

      <div>
        <div className="flex items-center gap-4 mb-2">
  <span className="text-2xl text-gray-400 line-through">
    ₹499
  </span>

  <span className="text-4xl font-semibold text-[#111827]">
    ₹249
  </span>

  <span className="bg-red-500 text-white text-xs font-semibold px-3 py-1 rounded-full">
    50% OFF
  </span>
</div>


        <p className="text-sm text-gray-500 mt-1">
          7 Sachets • 25.2g
        </p>
      </div>

    </div>

    {/* BENEFITS */}
    <div className="grid grid-cols-2 gap-3 mb-8 font-semibold">

  <div className="bg-[#f8f5f0] rounded-xl px-4 py-3 text-[14px] text-[#333] flex items-center gap-2">
    <span>☕</span>
    <span>100% Premium Arabica</span>
  </div>

  <div className="bg-[#f8f5f0] rounded-xl px-4 py-3 text-[14px] text-[#333] flex items-center gap-2">
    <span>🍄</span>
    <span>100% Fruiting Body</span>
  </div>

  <div className="bg-[#f8f5f0] rounded-xl px-4 py-3 text-[14px] text-[#333] flex items-center gap-2">
    <span>⚡</span>
    <span>Instant Energy</span>
  </div>

  <div className="bg-[#f8f5f0] rounded-xl px-4 py-3 text-[14px] text-[#333] flex items-center gap-2">
    <span>🧠</span>
    <span>Focus & Clarity</span>
  </div>

  <div className="bg-[#f8f5f0] rounded-xl px-4 py-3 text-[14px] text-[#333] flex items-center gap-2">
    <span>🌿</span>
    <span>Wellness Meets Ritual</span>
  </div>

  <div className="bg-[#f8f5f0] rounded-xl px-4 py-3 text-[14px] text-[#333] flex items-center gap-2">
    <span>🎒</span>
    <span>Travel Ready</span>
  </div>

</div>

    {/* BUTTONS */}
    <div className="flex flex-col sm:flex-row gap-4">

      {/* WHATSAPP */}
      <a
        href="https://wa.me/917659977997"
        target="_blank"
        rel="noopener noreferrer"
        className="bg-[#111] hover:bg-[#222] text-white px-6 py-3 rounded-full text-center transition duration-300"
      >
        Buy via WhatsApp
      </a>

      {/* AMAZON */}
      <a
        href="https://www.amazon.in/dp/B0GZZY3PHR"
        className="bg-[#d68c45] hover:bg-[#bf7a35] text-white px-6 py-3 rounded-full text-center transition duration-300"
      >
        Buy on Amazon
      </a>

    </div>

  </div>

</div>

{/* ================= CHOCOSHROOM SHOWCASE ================= */}

<div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center bg-white rounded-[32px] overflow-hidden shadow-lg border border-[#ece7df] mt-12">

  {/* LEFT SIDE — PRODUCT DETAILS */}
  <div className="p-6 sm:p-7 order-2 lg:order-1">

    {/* TITLE */}
    <h3 className="text-2xl sm:text-[32px] font-semibold text-[#1a1a1a] uppercase mb-4">
      Chocoshroom
    </h3>

    {/* LABEL */}
    <p className="text-[#d68c45] text-sm font-medium tracking-[3px] uppercase mb-2">
      Relax & Unwind Blend
    </p>

    

    {/* DESCRIPTION */}
    <p className="text-gray-600 text-[17px] leading-8 mb-6 max-w-xl">
      Meet CHOCOSHROOM (Cacao Mushroom) a thoughtfully crafted daily ritual that blends the richness of non-alkalized, unsweetened, slow-roasted cacao with the power of functional fruiting body mushroom extracts for soothing calm, gentle balance, and a more intentional way to unwind.
    </p>

    <p className="alex-font text-[22px] text-[#5c4033] leading-tight mb-4">
        Relax Better. Unwind Better. Feel Better.
    </p>

    {/* PRICE + WEIGHT */}
    <div className="flex items-center justify-between mb-6">

      <div>
        <div className="flex items-center gap-4 mb-2">
  <span className="text-2xl text-gray-400 line-through">
    ₹499
  </span>

  <span className="text-4xl font-semibold text-[#111827]">
    ₹249
  </span>

  <span className="bg-red-500 text-white text-xs font-semibold px-3 py-1 rounded-full">
    50% OFF
  </span>
</div>


        <p className="text-sm text-gray-500 mt-1">
          7 Sachets • 25.2g
        </p>
      </div>

    </div>

    {/* BENEFITS */}
    <div className="grid grid-cols-2 gap-3 mb-8 font-semibold">

  <div className="bg-[#f8f5f0] rounded-xl px-4 py-3 text-[14px] text-[#333] flex items-center gap-2">
    <span>🍫</span>
    <span>Rich Cacao</span>
  </div>

  <div className="bg-[#f8f5f0] rounded-xl px-4 py-3 text-[14px] text-[#333] flex items-center gap-2">
    <span>🍄</span>
    <span>100% Fruiting Body</span>
  </div>

  <div className="bg-[#f8f5f0] rounded-xl px-4 py-3 text-[14px] text-[#333] flex items-center gap-2">
    <span>😌</span>
    <span>Soothing Calm</span>
  </div>

  <div className="bg-[#f8f5f0] rounded-xl px-4 py-3 text-[14px] text-[#333] flex items-center gap-2">
    <span>🌙</span>
    <span>Relax & Unwind</span>
  </div>

  <div className="bg-[#f8f5f0] rounded-xl px-4 py-3 text-[14px] text-[#333] flex items-center gap-2">
    <span>🌿</span>
    <span>Wellness Meets Ritual</span>
  </div>

  <div className="bg-[#f8f5f0] rounded-xl px-4 py-3 text-[14px] text-[#333] flex items-center gap-2">
    <span>🎒</span>
    <span>Travel Ready</span>
  </div>

</div>

    {/* BUTTONS */}
    <div className="flex flex-col sm:flex-row gap-4">

      {/* WHATSAPP */}
      <a
        href="https://wa.me/917659977997"
        target="_blank"
        rel="noopener noreferrer"
        className="bg-[#111] hover:bg-[#222] text-white px-6 py-3 rounded-full text-center transition duration-300"
      >
        Buy via WhatsApp
      </a>

      {/* AMAZON */}
      <a
        href="https://www.amazon.in/dp/B0H11GYWBP"
        className="bg-[#d68c45] hover:bg-[#bf7a35] text-white px-6 py-3 rounded-full text-center transition duration-300"
      >
        Buy on Amazon
      </a>

    </div>

  </div>

  {/* RIGHT SIDE — IMAGE SHOWCASE */}
  <div className="bg-[#f7f2eb] h-full flex items-center justify-center p-4 sm:p-6 order-1 lg:order-2">

    <div className="w-full max-w-[520px]">

      <Swiper
        modules={[Autoplay, EffectFade]}
        effect="fade"
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        loop={true}
        className="rounded-[28px] overflow-hidden"
      >
        <SwiperSlide>
          <img
            src={choco3}
            alt="Chocoshroom"
            className="w-full object-cover rounded-[28px]"
          />
        </SwiperSlide>

        <SwiperSlide>
          <img
            src={choco4}
            alt="Chocoshroom"
            className="w-full object-cover rounded-[28px]"
          />
        </SwiperSlide>

        <SwiperSlide>
          <img
            src={choco1}
            alt="Chocoshroom"
            className="w-full object-cover rounded-[28px]"
          />
        </SwiperSlide>

        <SwiperSlide>
          <img
            src={choco2}
            alt="Chocoshroom"
            className="w-full object-cover rounded-[28px]"
          />
        </SwiperSlide>
        <SwiperSlide>
          <img
            src={choco5}
            alt="Chocoshroom"
            className="w-full object-cover rounded-[28px]"
          />
        </SwiperSlide>
        <SwiperSlide>
          <img
            src={choco6}
            alt="Chocoshroom"
            className="w-full object-cover rounded-[28px]"
          />
        </SwiperSlide>

      </Swiper>

    </div>

  </div>

</div>
  </div>
</section>


{/* ================= REVIEWS SECTION ================= */}

<section className="py-16 sm:py-20 px-4 sm:px-6 bg-[#f7f2eb]">

  <div className="max-w-6xl mx-auto">

    {/* SECTION TITLE */}
    <div className="text-center mb-14">

      <p className="text-[#d68c45] uppercase tracking-widest font-medium mb-3">
        Customer Love
      </p>

      <h2 className="text-xl sm:text-2xl font-semibold text-[#1a1a1a] mb-4">
        What Our Customers Say
      </h2>

      <p className="text-gray-500 max-w-2xl mx-auto">
        Trusted by wellness-focused coffee and chocolate lovers who enjoy our rich functional blends.
      </p>

    </div>

    {/* REVIEW GRID */}
    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">

      {/* REVIEW 1 */}
      <div className="bg-white rounded-[28px] p-8 shadow-md border border-[#ece7df]">

        <div className="flex text-[#d68c45] text-xl mb-4">
          ★★★★★
        </div>

        <p className="text-gray-600 leading-relaxed mb-6">
          “Absolutely love the smooth taste and calm focus Moffee gives me during work hours.”
        </p>

        <div>
          <h4 className="font-semibold text-[#1a1a1a]">
            Priya Sharma
          </h4>

          <p className="text-sm text-gray-400">
            Bangalore
          </p>
        </div>

      </div>

      {/* REVIEW 2 */}
      <div className="bg-white rounded-[28px] p-8 shadow-md border border-[#ece7df]">

        <div className="flex text-[#d68c45] text-xl mb-4">
          ★★★★★
        </div>

        <p className="text-gray-600 leading-relaxed mb-6">
          “Chocoshroom feels like a comforting wellness drink. Rich chocolate taste with relaxing vibes.”
        </p>

        <div>
          <h4 className="font-semibold text-[#1a1a1a]">
            Rahul Verma
          </h4>

          <p className="text-sm text-gray-400">
            Hyderabad
          </p>
        </div>

      </div>

      {/* REVIEW 3 */}
      <div className="bg-white rounded-[28px] p-8 shadow-md border border-[#ece7df]">

        <div className="flex text-[#d68c45] text-xl mb-4">
          ★★★★★
        </div>

        <p className="text-gray-600 leading-relaxed mb-6">
          “Finally found a coffee alternative that tastes premium and actually feels good for my body.”
        </p>

        <div>
          <h4 className="font-semibold text-[#1a1a1a]">
            Sneha Reddy
          </h4>

          <p className="text-sm text-gray-400">
            Chennai
          </p>
        </div>

      </div>

    </div>

  </div>

</section>
      {/* CONTACT */}
      <Contact/>

      {/* FOOTER */}
      {/* ================= FOOTER ================= */}

<footer className="bg-[#0a0503] text-white px-6 py-14">

  <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-16">

    {/* BRAND */}
    <div>

  <img
    src={MMLogopdf}
    alt="Moffee Magic"
    className="w-[180px] mb-6"
  />

  <div className="flex gap-4">

    <a
      href="https://instagram.com/moffeemagic"
      target="_blank"
      rel="noopener noreferrer"
      className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#d68c45] transition"
    >
      <FaInstagram className="text-white text-lg" />
    </a>

    <a
      href="https://facebook.com/moffeemagic"
      target="_blank"
      rel="noopener noreferrer"
      className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#d68c45] transition"
    >
      <FaFacebookF className="text-white text-lg" />
    </a>

  </div>

</div>

  <div className="flex flex-col gap-10">

  {/* QUICK LINKS */}
  <div>
    <h3 className="text-lg font-semibold mb-5">
      Quick Links
    </h3>

    <div className="flex flex-col gap-3 text-gray-400">
      <a href="#home" className="hover:text-[#d68c45] transition">
        Home
      </a>

      <a href="#products" className="hover:text-[#d68c45] transition">
        Products
      </a>

      <a href="#contact" className="hover:text-[#d68c45] transition">
        Contact
      </a>
    </div>
  </div>

  {/* CONTACT */}
  <div>
  <h3 className="text-lg font-semibold mb-5">
    Contact
  </h3>

  <div className="flex flex-col gap-4 text-gray-400">

    <div className="flex items-center gap-3 hover:text-white transition duration-300">
  <MdEmail className="text-[#d68c45] text-xl" />
  <span>hello@moffeemagic.com</span>
</div>

<div className="flex items-center gap-3 hover:text-white transition duration-300">
  <FaPhoneAlt className="text-[#d68c45] text-sm" />
  <span>+91 76599 77997</span>
</div>

  </div>
</div>

</div>

  </div>

  {/* BOTTOM */}
  <div className="border-t border-white/10 mt-12 pt-6 text-center text-gray-500 text-sm">

    © 2026 Moffee Magic. All rights reserved.

  </div>

</footer>

    </div>
  );
}